import React, { useState, useEffect } from "react";
import { app } from "../firebase";
import axios from 'axios';

// const firestoreApiBaseUrl = `https://firestore.googleapis.com/v1/projects/cinesage1/databases/(default)/documents`;
const firebaseConfig = {
    apiKey: "AIzaSyCXJ6Rno09i5sn-UeEUX7W_Y9XvimpAtg8",
    authDomain: "cinesage1.firebaseapp.com",
    projectId: "cinesage1",
    storageBucket: "cinesage1.appspot.com",
    messagingSenderId: "106512199048",
    appId: "1:106512199048:web:056e439677dfb1f880de3d"
};

const firestoreApiBaseUrl = `https://firestore.googleapis.com/v1/projects/${firebaseConfig.projectId}/databases/(default)/documents`;
function Fetch() {
    const [allDocs, setAllDocs] = useState([]);
    const [singleDoc, setSingleDoc] = useState({});
    const [searchInput, setSearchInput] = useState("");

    const fetchAll = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.get(`${firestoreApiBaseUrl}/Movies`);
            const fetchedDocs = response.data.documents.map((doc) => doc.fields);

            // Apply search filter based on the title
            const filteredDocs = fetchedDocs.filter((doc) =>
                doc.title.stringValue.toLowerCase().includes(searchInput.toLowerCase())
            );

            setAllDocs(filteredDocs);
        } catch (error) {
            console.error("Error fetching all documents: ", error);
        }
    };

    const fetchSingle = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.get(`${firestoreApiBaseUrl}/Movies/001B6KLdeG25ZczHa51M`);

            if (response.data.fields) {
                setSingleDoc(response.data.fields);
            } else {
                console.log("Document not found");
            }
        } catch (error) {
            console.error("Error fetching single document: ", error);
        }
    };

    return (
        <div>
            <h1>Fetching Data</h1>
            <input
                type="text"
                placeholder="Search by Title"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            <button onClick={fetchAll}>Fetch all docs</button>
            <button onClick={fetchSingle}>Fetch Single Doc</button>

            <h2>Single Document:</h2>
            <div>
                <h1>{singleDoc.title}</h1>
                <h1>{singleDoc.movieId}</h1>
                <h1>{singleDoc.genres}</h1>
            </div>

            <h2>All Documents:</h2>
            <ul>
                {allDocs.map((doc) => (
                    <li key={doc.movieId.stringValue}>
                        <h3>{doc.title.stringValue}</h3>
                        <p>{doc.genres.stringValue}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Fetch;
